var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7224 12.7134C17.9253 13.7007 18.7751 15.0161 19.1813 16.5127C19.3594 17.1656 19.2219 17.8499 18.8095 18.3904C18.3939 18.9341 17.7628 19.2465 17.0786 19.2465M7.2648 12.7181C6.07442 13.7023 5.22772 15.002 4.82156 16.4861C4.64034 17.1485 4.77469 17.8421 5.19023 18.3889C5.59952 18.9294 6.23064 19.2418 6.91488 19.2418H14.2727",
    stroke: "currentColor",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 130",
    cx: 12,
    cy: 7.76137,
    r: 3.32767,
    stroke: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/ProfileIcon.0fa6704e2a4601b6b6dccb99dfb7cd96.svg";
export { ForwardRef as ReactComponent };